function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.4494 34.9003H14.4167C12.2502 34.9003 10.4932 33.1433 10.4932 30.9768V30.9768C10.4932 28.8103 12.2502 27.0533 14.4167 27.0533H25.7584C27.9249 27.0533 29.6819 25.2963 29.6819 23.1298V23.1263C29.6819 20.9598 27.9249 19.2028 25.7584 19.2028H20.9599",
  stroke: "#323232",
  strokeWidth: 2.625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.1058 19.1992C13.1058 19.1992 7 14.1838 7 9.60575C7 6.2335 9.7335 3.5 13.1058 3.5C16.478 3.5 19.2115 6.2335 19.2115 9.60575C19.2115 14.1855 13.1058 19.1992 13.1058 19.1992Z",
  stroke: "#323232",
  strokeWidth: 2.625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1045 9.34328C12.863 9.34328 12.6687 9.53928 12.6687 9.78078C12.6687 10.0205 12.8647 10.2165 13.1045 10.2165C13.346 10.2165 13.5402 10.0205 13.5402 9.78078C13.542 9.53928 13.346 9.34328 13.1045 9.34328",
  stroke: "#323232",
  strokeWidth: 2.625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M34.9991 33.0575L31.3066 36.75",
  stroke: "#323232",
  strokeWidth: 2.625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M31.3066 33.0575L34.9991 36.75",
  stroke: "#323232",
  strokeWidth: 2.625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgNavigationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = React.forwardRef(SvgNavigationIcon);
export default __webpack_public_path__ + "static/media/navigation_icon.4db0fbb7.svg";
export { ForwardRef as ReactComponent };